import React from "react";
import { GoArrowUpRight } from "react-icons/go";
import { IoSettingsOutline } from "react-icons/io5";
import {User,Bitly,Savemessage, Url,Voice, Pin, Link, Thumbnail, Message, Media, UserStatus} from "../../Iocn/iocn"






export const cardData = [
  {
    icon: UserStatus,
    // settingIcon: <IoSettingsOutline />,
    title: "Live Status (Admin)",
    content:
      "Live Status (Admin)",
    arrowIcon: <GoArrowUpRight />,
    enabled: true,
  },

  {
    icon: UserStatus,
    // settingIcon: <IoSettingsOutline />,
    title: "Live Status (Consumer)",
    content:
      "Live Status (Consumer)",
    arrowIcon: <GoArrowUpRight />,
    enabled: true,
  }


];
